import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Me } from "types/user";
import { api } from "utils/api";

export function useUser() {
  const queryClient = useQueryClient();
  const user = useQuery<Me>(["me"], () => api.get("/users/v1/users/me"), {
    retry: false,
  });

  const { mutateAsync: signOut } = useMutation(
    () => api.delete("/users/v1/auth/signout"),
    {
      onSuccess: () => queryClient.removeQueries(["me"]),
    }
  );
  return { ...user, signOut };
}
